import React from 'react';
import { Card } from 'react-bootstrap';
import {
  FaClock,
  FaTasks,
  FaDollarSign,
  FaFileAlt,
  FaChartLine,
  FaCircle
} from 'react-icons/fa';

const palette = [
  "#AD1B02",  // 0 Rojo PwC
  "#000000",  // 1 Negro
  "#D85604",  // 2 Terracota
  "#E88D14",  // 3 Naranja claro
  "#F3BE26",  // 4 Amarillo
  "#E669A2",  // 5 Rosa
  "#FFFFFF"   // 6 Blanco
];

// Asocia cada label a un icono
const iconMap = {
  Tiempo:       FaClock,
  Entregables:  FaTasks,
  Facturación:  FaDollarSign,
  Administrativa: FaFileAlt,
  Rentabilidad: FaChartLine
};

const PortfolioCard = ({ title, metrics, styles: css, img }) => {
  return (
    <Card className={css.boxShadow}>
      <Card.Header className={css.CardHeader}>
        {img}
        <span style={{ marginLeft: 8, fontWeight: 600 }}>{title}</span>
      </Card.Header>
      <Card.Body>
        {metrics.map((m, i) => {
          const Icon = iconMap[m.label] || FaCircle;
          const color = palette[m.colorIndex % palette.length];
          return (
            <div
              key={m.label}
              className="d-flex align-items-center mb-2"
              style={{ gap: '0.75rem' }}
            >
              <Icon 
                color={color} 
                size={18} 
              />
              <span
                className="flex-grow-1"
                style={{ fontWeight: 700, color: '#555' }}
              >
                {m.label}
              </span>
              <FaCircle color={color} size={12} />
            </div>
          );
        })}
      </Card.Body>
    </Card>
  );
};

export default PortfolioCard;
